export class AuthorizationDTO{
  public FK_user : string;
  public Email : string;
  public FK_Company : number;
}
